import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { selectProfileData } from '../store/selectors';
import { IUseViewControl } from './useViewControl.type';

const useViewControl = (): IUseViewControl => {
  const [searchParams, setSearchParams] = useSearchParams();

  const userProfile = useSelector(selectProfileData);
  const [activeView, setActiveView] = useState<'profile' | 'team'>('profile');

  const { naturalPerson, legalRepresentative } = userProfile || {};
  const { name, lastName } = naturalPerson || {};
  const { roleId } = legalRepresentative || {};

  const fullName = `${name} ${lastName?.charAt(0)}.`;

  useEffect(() => {
    if (searchParams.get('view') === 'team') {
      setActiveView('team');
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  return { activeView, fullName, roleId, setActiveView };
};

export default useViewControl;
